import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CelebrationIcon from '@mui/icons-material/Celebration';
import { useAuth0 } from '@auth0/auth0-react';
import { Link } from 'react-router-dom';
import { FREE_SUBSCRIPTION_MONTHS } from 'constants/subscription';

export default function PromoBanner() {
  const { t } = useTranslation();
  const { loginWithRedirect } = useAuth0();

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        py: { xs: 4, md: 6 },
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)',
        }
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 3,
          }}
        >
          {/* Icon and Text */}
          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, flex: 1 }}>
            <CelebrationIcon
              sx={{
                fontSize: { xs: 40, md: 50 },
                color: '#ffd700',
                animation: 'bounce 2s infinite',
                '@keyframes bounce': {
                  '0%, 100%': { transform: 'translateY(0)' },
                  '50%': { transform: 'translateY(-10px)' },
                },
              }}
            />
            <Box>
              <Typography
                variant="h4"
                sx={{
                  color: 'white',
                  fontWeight: 800,
                  mb: 1,
                  fontSize: { xs: '1.5rem', md: '2rem' },
                  textShadow: '2px 2px 4px rgba(0,0,0,0.2)',
                }}
              >
                {t('Limited Time Offer')}
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: 'rgba(255,255,255,0.95)',
                  fontSize: { xs: '1rem', md: '1.25rem' },
                  fontWeight: 500,
                  lineHeight: 1.6,
                }}
              >
                {t('Create your catalog today and get {{count}} month free subscription', { count: FREE_SUBSCRIPTION_MONTHS })}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: 'rgba(255,255,255,0.85)',
                  mt: 1,
                  fontSize: { xs: '0.875rem', md: '1rem' },
                }}
              >
                {t('Start building your digital menu now and enjoy {{count}} month completely free', { count: FREE_SUBSCRIPTION_MONTHS })}
              </Typography>
            </Box>
          </Box>

          {/* CTA Button */}
          <Link
            to="/"
            onClick={() => loginWithRedirect({ screen_hint: 'signup' })}
            style={{ textDecoration: 'none' }}
          >
            <Button
              variant="contained"
              size="large"
              sx={{
                bgcolor: 'white',
                color: '#667eea',
                fontWeight: 700,
                px: 4,
                py: 1.5,
                fontSize: { xs: '1rem', md: '1.1rem' },
                borderRadius: 3,
                boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                textTransform: 'none',
                whiteSpace: 'nowrap',
                '&:hover': {
                  bgcolor: '#f8f9fa',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 12px 24px rgba(0,0,0,0.3)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              {t('Get Started Free')}
            </Button>
          </Link>
        </Box>
      </Container>
    </Box>
  );
}

